<template>
  <Catalogs
    title="Статусы объявления"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'JobPostingStatusAdd'"
    :route-edit="'JobPostingStatusEdit'"
    :route-view="'JobPostingStatusView'"
    :route-path="'/job_posting_statuses'"
    :can-edit="canEditJobPostingStatuses()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "JobPostingStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'job-posting-status-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'job-posting-status-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getJobPostingStatuses(data);
    },
    canEditJobPostingStatuses() {
      return this.hasPermission([PERM.CATALOG_JOB_POSTING_STATUS_EDIT]);
    }
  }
}
</script>

<style>
.job-posting-status-id {
  width: 60px;
  text-align: center;
}

.job-posting-status-action {
  width: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/JobPostingStatuses/JobPostingStatuses.vue